<template>
    <div class="card">
        <div class="card-header">
            <h4 class="card-title">
                {{$t("productosMasVendidos")}}
            </h4>
            <p class="card-category">
                {{$t("rankingDeLaSesionActual")}}
            </p>
            <div class="text-right">
                <router-link :to="{name:'online-products', params:{idBusiness:idBusiness}}">
                    <span class="verTodos"><i class="fa fa-eye"></i> {{$t("verTodos")}}</span>
                </router-link>
            </div>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-md-12">
                    <table class="table table-bordered table-striped ">
                        <thead class="thead-dark">
                        <tr>
                            <th>{{$t("productos")}}</th>
                            <th>{{$t("uds")}}.</th>
                            <th>{{$t("importe")}}</th>
                            <th>{{$t("precioMed")}}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="product in products.slice(0, 5)">
                            <td>{{product.product}}</td>
                            <td>{{Math.abs(product.units)}}</td>
                            <td align="right">{{product.import | currency}}</td>
                            <td align="right">{{(product.import / product.units) | currency}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="card-footer">
            <hr>
            <div class="stats">
                <i class="fa fa-clock"></i> {{lastDate | timeago}}
            </div>
        </div>
    </div>
</template>
<script>

    import swal from 'sweetalert2'
    import Ticket from '../../../Widgets/Ticket.vue'

    export default {

        created() {
            this.getProductosMasVendidos();
        },
        props: ['onlineDetails', 'lastDate', 'idBusiness'],
        data() {
            return {
                products: []
            }
        },
        components: {
            Ticket,
        },
        methods: {
            getProductosMasVendidos() {

                var tpvs = [];
                this.onlineDetails.forEach(function (x) {
                    if (x && x.online == 1) {
                        tpvs.push(x.idTpv);
                    }
                });


                var config = {
                    params: {
                        idBusiness: this.idBusiness,
                        listTpv: JSON.stringify(tpvs),
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "online/getProductosMasVendidos", config)
                    .then(function (response) {
                        if (response.data.response) {
                            vm.products = response.data.result.listProducts;
                        } else {
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },

        },
        watch: {
            onlineDetails: function (newOnlineDetails, oldOnlineDetails) {
                this.getProductosMasVendidos();
            }
        },


    }
</script>
<style scoped>
    .card-body {
        padding: 10px 15px;
    }

    .title {
        font-weight: bold;
    }

    tfoot tr td {
        font-size: 1.2em;
        color: #fff;
        text-shadow: 1px 1px #111;
        font-weight: bold;
    }

    .card-category {
        color: #9a9a9a
    }

    .verTodos {
        font-size: 0.9em
    }


</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Online/Widgets/ProductosMasVendidos.vue